import { getComponentContentById } from "@cappelendamm/crystallize-utils";
import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
import { getBookFromProductVariant } from "../../product/selectors/getBookFromProductVariant.js";
export const getSubscriptionCampaignBooks = (subscription) => {
    const campaignBooksContent = getComponentContentById(subscription.components, CRYSTALLIZE_IDS.SHAPE.PRODUCT.SERIES_SUBSCRIPTION.VARIANT.CAMPAIGN_BOOKS.ID)?.chunks;
    if (!campaignBooksContent || campaignBooksContent.length === 0) {
        return [];
    }
    // Campaign books are expected to be only one chunk
    const content = campaignBooksContent[0];
    const productVariants = getComponentContentById(content, CRYSTALLIZE_IDS.SHAPE.PRODUCT.SERIES_SUBSCRIPTION.VARIANT.CAMPAIGN_BOOKS
        .BOOKS)?.productVariants;
    if (!productVariants) {
        return [];
    }
    const books = productVariants.map(getBookFromProductVariant);
    return books.sort((a, b) => {
        if (a.numberInSeries === undefined)
            return 1;
        if (b.numberInSeries === undefined)
            return -1;
        return a.numberInSeries - b.numberInSeries;
    });
};
